import { Sorts } from "../../pagination/models/typies/sorts.type";
import { booleanValidation, numberValidation, sortValidation, stringValidation } from "../params.validators";

type ParamsConfigValidators = {
  [K in keyof ParamsConfig]: (value: any) => any | undefined;
};

export const paramsConfig: ParamsConfigValidators = {
  page: numberValidation,
  search: stringValidation,
  sort: sortValidation,
  isActive: booleanValidation,
  userId: numberValidation,
  serviceId: numberValidation,
} as const;

export interface ParamsConfig {
  page: number,
  search: string,
  sort: Sorts,
  isActive: boolean,
  userId: number,
  serviceId: number,
}
